export default __webpack_public_path__ + "static/mercedes_benz-791dbfbcbdecf1922efcdc5dc4196f00.png";